export const blockIconsBusinessandpaymentsQrCodeNew = (
	<span className='material-symbols-outlined'>qr_code</span>
);
